"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hopinTheme = void 0;
var tslib_1 = require("tslib");
var COLOR = tslib_1.__importStar(require("./partials/color"));
var LAYOUT = tslib_1.__importStar(require("./partials/layout"));
var LINE = tslib_1.__importStar(require("./partials/line"));
var MOTION = tslib_1.__importStar(require("./partials/motion"));
var PLANE = tslib_1.__importStar(require("./partials/plane"));
var SCALE = tslib_1.__importStar(require("./partials/scale"));
var TYPOGRAPHY = tslib_1.__importStar(require("./partials/typography"));
exports.hopinTheme = {
    COLOR: COLOR,
    LAYOUT: LAYOUT,
    LINE: LINE,
    MOTION: MOTION,
    PLANE: PLANE,
    SCALE: SCALE,
    TYPOGRAPHY: TYPOGRAPHY,
};
//# sourceMappingURL=hopin-theme.js.map